import { Form } from "antd";

export default () => {
  const [fields] = Form.useForm();

  return { fields };
};
